<div class="py-20">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Title -->
    <div class="text-center mb-16">
      <h2 class="h2 text-text-primary tracking-tight">
        {{ 'about.team.title' | translate }}
      </h2>
    </div>

    <!-- Team Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      @for (m of teamMembers; track m.id) {
        <app-our-team-card [member]="m"></app-our-team-card>
      }
    </div>
  </div>
</div>
